import Head from 'next/head';
import React from 'react';
import { DEFAULT_LANG } from '../../common/helpers/constants';

interface SeoHeaderProps {
  title?: string;
  description?: string;
  canonicalLink?: string;
  imageUrl?: string;
  ogType?: string;
}

const SeoHeader: React.FC<SeoHeaderProps> = ({
  title = '',
  description = '',
  canonicalLink = '',
  imageUrl = '',
  ogType = 'website',
}) => {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={canonicalLink} />
      <meta property="og:type" content={ogType} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta name="msvalidate.01" content="3E21B2ACA209D27F793776F0DFA88C89" />
      <link rel="canonical" href={canonicalLink} />
      <link rel="alternate" href={canonicalLink} hrefLang={DEFAULT_LANG} />
    </Head>
  );
};

export default SeoHeader;
